import React from 'react';

const Dashboard = () => {
  return (
    <div className="container p-4 text-start">
     <center><h1 className="mb-4">Admin Dashboard</h1></center> 
<hr />
      <h2>🚀 How to Add a Product and Category</h2>

      {/* Adding a New Category */}
      <h3>📂 Adding a New Category</h3>
      <p>
        1. **Go to the Admin Panel** and navigate to the *Manage Category* section. | <br />
        2. **Enter the Category Name** in the input field. | <br />
        3. **Write a Description** for the category. | <br />
        4. **Upload an Image** (*Only one image can be uploaded at a time*). | <br />
        5. **Click on "Add Category"** to save the new category. | <br />
        6. **Success Message Appears!** Your category is now added. | <br />
        7. Use * * (put content Double star ) to bold any text in the content  |
      </p>

      {/* Adding a New Product */}
      <h3>🛍️ Adding a New Product</h3>
      <p>
        1. **Go to the Admin Panel** and open the *Manage Product* section. | <br />
        2. **Enter the Product Name** in the required field. | <br />
        3. **Select a Category** from the dropdown menu. | <br />
        4. **Provide a Description** of the product. | <br />
        5. **Set the Price** and other details. | <br />
        6. **Upload an Image** (*Only one image can be uploaded at a time*). | <br />
        7. **Click on "Add Product"** to save the product. | <br />
        8. **Success Message Appears!** Your product is now listed. | <br />
        9. Use * * (put content Double star ) to bold any text in the content  |
      </p>

      {/* Important Notes */}
      <h3>🎯 Important Notes</h3>
      <ul>
        <li>Ensure all required fields are filled before submitting. |</li>
        <li>If you face issues, refresh the page and try again. |</li>
        <li>Contact support for technical assistance. |</li>
      </ul>

      <p>🚀 Now you're all set to manage your categories and products efficiently! 🎉</p>
    </div>
  );
};

export default Dashboard;

